<template>
  <div class="body">
    <div class="title">
      体彩首页轮播设置
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/lotteryTicket' }"
            ><span class="dsadf"> 配置中心 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/lotteryTicket' }"
            >体彩配置</el-breadcrumb-item
          >
          <el-breadcrumb-item>
            {{ $route.query.id ? "修改" : "添加" }}体彩首页轮播
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div style="margin: -20px 0 20px">
      <el-button size="mini" @click="$router.back()">返回</el-button>
    </div>

    <el-card>
      <el-form
        ref="form"
        :model="banner"
        label-width="80px"
        :label-position="labelPosition"
      >
        <el-form-item label="标题" label-width="10%" prop="name">
          <el-input
            v-model="banner.name"
            style="width: 50%"
            placeholder="输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片" label-width="10%">
          <MultipleUploadSWithDragort
            :uploadedList.sync="banner.pic"
            :uploadMaxLen="1"
            name="pic"
          >
          </MultipleUploadSWithDragort>
          <div class="tip" style="color: #86909c">
            推荐 686 x 286px 的jpg
            <br />
            图形压缩工具>
            <a target="_blank" href="https://tinypng.com">
              https://tinypng.com
            </a>
          </div>
        </el-form-item>
        <el-form-item label="链接" label-width="10%">
          <el-radio-group v-model="banner.url_type">
            <el-radio :label="1">内部链接</el-radio>
            <el-radio :label="3">外部链接</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="链接地址" label-width="10%" prop="url">
          <el-input
            v-model="banner.url"
            style="width: 50%"
            placeholder="内部链接 /pages/xxxx/xxxx  外部链接 https://xxx.xxx.xxx"
          ></el-input>
        </el-form-item>

        <el-form-item label="排序" label-width="10%" prop="url">
          <el-input
            v-model="banner.sort"
            style="width: 50%"
            placeholder="数值越小越靠前"
          ></el-input>
          <div class="tip" style="color: #86909c">
            序号越小优先级越高; 当序号相等时，时间进优先
            <br />
          </div>
        </el-form-item>
        <el-form-item label="活动时间" label-width="10%" prop="s_date">
          <el-date-picker
            v-model="banner.s_date"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="banner.e_date"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="启用状态" label-width="10%">
          <el-radio-group v-model="banner.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">未启用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="handleCommit">提交</el-button>
    </el-card>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import {
  addBannerWithLotteryTicketBanner,
  editBannerWithLotteryTicketBanner,
  getBannerDetailWithLotteryTicketBanner,
} from "@/api/configuration-center";
import MultipleUploadSWithDragort from "@/components/MultipleUploadWithDragSort/index.vue";

export default {
  name: "LotteryTicketEdit",
  data() {
    return {
      banner: {
        pic: [],
        status: 1,
        url_type: 3,
        s_date: "",
        e_date: "",
        sort: 99,
      },
      token: sessionStorage.getItem("token"),
      labelPosition: "left",
    };
  },
  components: { MultipleUploadSWithDragort },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.$route.query.id) {
        getBannerDetailWithLotteryTicketBanner({
          id: this.$route.query.id,
          token: this.token,
        }).then((resp) => {
          console.log("_getBannerDetailWithLotteryTicketBanner", resp);
          let data = resp.data.data;
          this.banner = { ...data, pic: [data.pic] };
        });
      }
    },
    handleCommit() {
      let banner = cloneDeep(this.banner);
      banner.pic = banner.pic[0];
      console.log("_commit", banner);
      if (!banner.s_date || !banner.e_date) {
        return this.$message({
          message: "活动时间必须选择",
          type: "error",
          duration: "2000",
        });
      }
      if (banner.id) {
        editBannerWithLotteryTicketBanner({
          ...banner,
          token: this.token,
        }).then((res) => {
          console.log(res);
          if (res.data.result === 0) {
            this.$message({
              message: res.data.msg,
              type: "error",
              duration: "2000",
            });
            return;
          }
          if (res.data.result === 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: "2000",
            });
            setTimeout(() => {
              this.$router.push("/lotteryBanner");
            }, 2000);
          }
        });
      } else {
        addBannerWithLotteryTicketBanner({
          ...banner,
          token: this.token,
        }).then((res) => {
          if (res.data.result === 0) {
            this.$message({
              message: res.data.msg,
              type: "error",
              duration: "2000",
            });
            return;
          }
          if (res.data.result === 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: "2000",
            });
            setTimeout(() => {
              this.$router.push("/lotteryBanner");
            }, 2000);
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.imgbox {
  width: 188px;
  height: 188px;
  opacity: 1;
  background: rgba(0, 0, 0, 0);
  border-radius: 5px;
  position: relative;
  .imgs {
    width: 100%;
    height: 100%;
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
    opacity: 1;
    background: #e54848;
    border-radius: 50%;
  }
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf {
      color: #3d9aff;
    }
  }
}
</style>
